import { API_URL } from '../config/apiConfig';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
};

export const getAllTeams = async () => {
    try {
        const response = await fetch(`${API_URL}/api/teams`, {
            method: 'GET',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to fetch teams');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in getAllTeams:', error);
        throw error;
    }
};

export const getTeam = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${id}`, {
            method: 'GET',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to fetch team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in getTeam:', error);
        throw error;
    }
};

export const createTeam = async (teamData) => {
    try {
        const response = await fetch(`${API_URL}/api/teams`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(teamData),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to create team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in createTeam:', error);
        throw error;
    }
};

export const updateTeam = async (id, teamData) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${id}`, {
            method: 'PATCH',
            headers: getAuthHeaders(),
            body: JSON.stringify(teamData),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to update team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in updateTeam:', error);
        throw error;
    }
};

export const deleteTeam = async (id) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to delete team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in deleteTeam:', error);
        throw error;
    }
};

export const addMemberToTeam = async (teamId, userId, isTeamLead = false) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${teamId}/members`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ userId, isTeamLead }),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to add member to team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in addMemberToTeam:', error);
        throw error;
    }
};

export const removeMemberFromTeam = async (teamId, userId) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${teamId}/members/${userId}`, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to remove member from team');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in removeMemberFromTeam:', error);
        throw error;
    }
};

export const setTeamLead = async (teamId, userId) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${teamId}/lead`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ userId }),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to set team lead');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in setTeamLead:', error);
        throw error;
    }
};

export const updateTeamProjects = async (teamId, projectIds) => {
    try {
        const response = await fetch(`${API_URL}/api/teams/${teamId}/projects`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ projectIds }),
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.error || 'Failed to update team projects');
        }
        
        return response.json();
    } catch (error) {
        console.error('Error in updateTeamProjects:', error);
        throw error;
    }
};
